import { render, staticRenderFns } from "./New_inspiration.vue?vue&type=template&id=31131582&scoped=true&"
import script from "./New_inspiration.vue?vue&type=script&lang=js&"
export * from "./New_inspiration.vue?vue&type=script&lang=js&"
import style0 from "./New_inspiration.vue?vue&type=style&index=0&id=31131582&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31131582",
  null
  
)

export default component.exports